import React from "react";

export default function UniComplyLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="55"
      height="52"
      viewBox="0 0 55 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.9046 5.06012C42.1935 4.62117 42.0728 4.02946 41.6235 3.75683C38.362 1.77762 34.6997 0.541505 30.8977 0.141866C26.78 -0.290967 22.6185 0.27002 18.7623 1.77777C14.9062 3.28551 11.4678 5.69604 8.73577 8.80714C6.21322 11.6797 4.36068 15.072 3.30666 18.7386C3.16147 19.2437 3.47411 19.7604 3.98417 19.8869L4.38742 19.9869C4.89748 20.1135 5.41165 19.8019 5.55866 19.2973C6.52223 15.9905 8.20004 12.9309 10.4779 10.337C12.9654 7.50454 16.0958 5.30986 19.6066 3.93713C23.1175 2.56439 26.9063 2.05364 30.6554 2.44772C34.0886 2.80859 37.3967 3.91864 40.3478 5.6949C40.798 5.96591 41.3872 5.8461 41.6761 5.40715L41.9046 5.06012Z"
        fill="url(#paint0_linear_6070_16208)"
      />
      <path
        d="M3.26217 25.126C2.7369 25.1099 2.29616 25.5227 2.29933 26.0482C2.32385 30.1183 3.30776 34.1302 5.17682 37.756C7.19138 41.6639 10.1679 44.9945 13.8259 47.4339C17.4838 49.8732 21.7027 51.3408 26.0848 51.6985C30.1504 52.0303 34.2322 51.3966 37.9991 49.8548C38.4855 49.6557 38.6972 49.0901 38.4804 48.6114L38.309 48.2329C38.0922 47.7542 37.529 47.5438 37.0419 47.7411C33.6343 49.1216 29.9465 49.6874 26.2734 49.3876C22.2837 49.062 18.4426 47.7258 15.1122 45.5049C11.7818 43.284 9.07183 40.2516 7.23766 36.6936C5.54902 33.4178 4.65395 29.7959 4.61851 26.1195C4.61345 25.594 4.20272 25.1549 3.67745 25.1388L3.26217 25.126Z"
        fill="url(#paint1_linear_6070_16208)"
      />
      <circle
        cx="3.88546"
        cy="25.4538"
        r="3.88546"
        fill="url(#paint2_linear_6070_16208)"
      />
      <path
        d="M41.4076 47.043C41.6861 47.4887 42.2743 47.6257 42.7094 47.331C45.6364 45.3488 48.1295 42.7862 50.0317 39.7987C52.1045 36.5433 53.4233 32.8657 53.8918 29.035C54.3602 25.2043 53.9664 21.3173 52.7392 17.6584C51.6129 14.3005 49.8108 11.2127 47.4477 8.58358C47.0964 8.19274 46.4925 8.18396 46.1149 8.54939L45.8163 8.83829C45.4386 9.20372 45.4302 9.80486 45.7801 10.197C47.9037 12.5768 49.5246 15.3655 50.541 18.3957C51.6583 21.727 52.0169 25.2659 51.5904 28.7536C51.1639 32.2413 49.9631 35.5895 48.076 38.5534C46.3593 41.2494 44.1143 43.5653 41.4798 45.3633C41.0457 45.6596 40.909 46.245 41.1874 46.6907L41.4076 47.043Z"
        fill="url(#paint3_linear_6070_16208)"
      />
      <circle
        cx="40.7566"
        cy="4.99484"
        r="3.88546"
        fill="url(#paint4_linear_6070_16208)"
      />
      <circle
        cx="43.2136"
        cy="45.6745"
        r="3.88546"
        fill="url(#paint5_linear_6070_16208)"
      />
      <path
        d="M29.27 29.534V19.8945C29.4194 18.6088 32.7475 18.7608 32.8613 19.8945V22.0147C32.8613 23.335 32.6498 23.3568 33.6029 23.3568H35.733C36.4774 23.4548 36.3898 23.9954 36.3898 24.5867V28.3973C36.3898 31.3687 33.8807 35.9786 25.5996 34.6339C28.8592 33.4939 29.27 30.9095 29.27 29.534Z"
        fill="url(#paint6_linear_6070_16208)"
      />
      <path
        d="M15.0645 29.9037C16.7677 39.8754 29.8981 42.4148 35.3485 33.3102C28.0269 38.159 22.1094 36.4188 22.1094 29.9037L22.0388 18.2417C21.9907 18.0113 22.1404 17.5729 21.579 17.4434H18.3306C17.7136 17.5195 17.7854 17.851 17.7854 18.2417V20.1168C17.8297 20.7119 17.7854 20.7843 17.0698 20.7493H15.7314C15.0645 20.7493 15.0645 20.7493 15.0645 21.2946V29.9037Z"
        fill="url(#paint7_linear_6070_16208)"
      />
      <path
        d="M46.4373 8.23626C45.9298 8.21221 45.4413 8.43957 45.1127 8.82708C43.3697 10.8824 41.9405 12.5337 40.6766 13.4003L41.1127 14.1143L41.8259 14.2333C42.3809 13.0439 45.8293 9.33529 47.0986 8.34364C46.9334 8.27531 46.7133 8.24938 46.4373 8.23626Z"
        fill="#0C7E9B"
      />
      <path
        d="M39.85 12.9679C39.5872 12.9679 39.3742 13.1815 39.3742 13.4442L39.3745 14.7611C38.554 16.0899 37.6171 16.9694 36.3834 17.552L38.2461 19.2166C38.7116 17.8207 39.6623 16.6843 40.8345 15.718L41.6488 15.7186C41.9113 15.7184 42.1237 15.505 42.1237 15.2425L42.1242 13.4434C42.124 13.1809 41.9106 12.9686 41.648 12.9686L39.85 12.9679Z"
        fill="url(#paint8_linear_6070_16208)"
      />
      <path
        d="M30.793 13.7394L33.4102 13.7401C33.6725 13.7404 33.8852 13.9527 33.8854 14.2151L33.8848 15.7193C34.5338 16.6887 35.3952 17.1942 36.6631 17.5914L35.315 19.3753C34.4729 18.1823 33.9094 17.704 32.6921 17.3073L30.7927 17.3077C30.53 17.3076 30.3174 17.0945 30.3174 16.8318L30.3172 14.2158C30.3172 13.953 30.5302 13.7394 30.793 13.7394Z"
        fill="url(#paint9_linear_6070_16208)"
      />
      <rect
        x="35.1035"
        y="17.2637"
        width="3.31404"
        height="3.31404"
        rx="0.475771"
        fill="#24C1D3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6070_16208"
          x1="12.2828"
          y1="7.65198"
          x2="53.2003"
          y2="52.4755"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6070_16208"
          x1="12.2828"
          y1="7.65198"
          x2="53.2003"
          y2="52.4755"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6070_16208"
          x1="1.49822"
          y1="22.7166"
          x2="7.63843"
          y2="29.443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6070_16208"
          x1="12.2828"
          y1="7.65198"
          x2="53.2003"
          y2="52.4755"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6070_16208"
          x1="38.3693"
          y1="2.25766"
          x2="44.5095"
          y2="8.98401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6070_16208"
          x1="40.8263"
          y1="42.9373"
          x2="46.9666"
          y2="49.6637"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5B5B" />
          <stop offset="1" stopColor="#969696" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6070_16208"
          x1="25.7401"
          y1="21.5366"
          x2="35.54"
          y2="22.9489"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.110577" stopColor="#0C7E9B" />
          <stop offset="0.370192" stopColor="#1FC1D3" />
          <stop offset="0.596154" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#3DC5D6" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6070_16208"
          x1="15.3284"
          y1="20.8927"
          x2="33.4033"
          y2="24.5122"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.110577" stopColor="#0C7E9B" />
          <stop offset="0.370192" stopColor="#1FC1D3" />
          <stop offset="0.596154" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#0A829D" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6070_16208"
          x1="44.6043"
          y1="16.0185"
          x2="37.2343"
          y2="20.8841"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.110577" stopColor="#0C7E9B" />
          <stop offset="0.364199" stopColor="#1FC1D3" />
          <stop offset="0.596154" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#19AFC4" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_6070_16208"
          x1="30.1194"
          y1="14.8327"
          x2="37.8058"
          y2="17.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C7E9B" />
          <stop offset="0.293269" stopColor="#1FC1D3" />
          <stop offset="0.480769" stopColor="#95D3DD" />
          <stop offset="0.776982" stopColor="#1FC1D3" />
          <stop offset="1" stopColor="#0A829D" />
        </linearGradient>
      </defs>
    </svg>
  );
}
